import Currencies from '@components/Currency/OrienbankRates';
import DisposalForm from '@components/Payments/forms/DisposalForm';

import { useTranslation } from 'react-i18next';

const Disposal = () => {
  const { t } = useTranslation();

  return (
    <div className='md:grid grid-cols-6 gap-10 mt-5'>
      <div className='col-span-4'>
        <p className='text-xl mb-5 color-active font-semibold'>{t('Disposal payment')}</p>
        <DisposalForm />
      </div>
      <div className='col-span-2 max-md:hidden'>
        <Currencies size='max-lg:text-xs text-sm' />
      </div>
    </div>
  );
};

export default Disposal;
